import type { CarOrderDetailDriverInfo } from "@/api/car";

import { hasAssignedDriver } from "../utils";

type Props = {
  driver: CarOrderDetailDriverInfo | null;
};

export default function CarDriverSection({ driver }: Props) {
  return (
    <div className="mx-4 mt-3 bg-white rounded-2xl p-4">
      <div className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
        <i
          className="ri-steering-2-line"
          style={{ color: "#2563EB", fontSize: 15 }}
        />
        派车司机
      </div>
      {!hasAssignedDriver(driver) ? (
        <div
          className="px-3 py-4 rounded-xl text-center text-xs text-gray-400 leading-relaxed"
          style={{ background: "#F8F8F8" }}
        >
          暂未派车，商家指派后将展示司机姓名、车牌与联系电话
        </div>
      ) : (
        <div className="p-3 rounded-xl" style={{ background: "#F0F4FF" }}>
          <div className="flex items-center gap-3">
            <div
              className="w-11 h-11 rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0"
              style={{ background: "#2563EB" }}
            >
              {driver.name?.trim()?.[0] ??
                driver.license_plate?.trim()?.[0] ??
                "司"}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-gray-900 truncate">
                {driver.name?.trim() || "—"}
              </div>
              <div className="text-xs text-gray-500 mt-0.5 space-y-0.5">
                {driver.license_plate?.trim() ? (
                  <div>车牌 {driver.license_plate.trim()}</div>
                ) : null}
                {driver.phone?.trim() ? (
                  <div className="text-gray-400">电话 {driver.phone.trim()}</div>
                ) : null}
                {driver.remark?.trim() ? (
                  <div className="text-gray-400 line-clamp-2">
                    备注 {driver.remark.trim()}
                  </div>
                ) : null}
              </div>
            </div>
            {driver.phone?.trim() ? (
              <a
                href={`tel:${driver.phone.replace(/\s/g, "")}`}
                className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 cursor-pointer"
                style={{ background: "#2563EB" }}
                aria-label="联系司机"
                onClick={(e) => e.stopPropagation()}
              >
                <i
                  className="ri-phone-line text-white"
                  style={{ fontSize: 18 }}
                />
              </a>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}
